import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const StudentSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleSignOut = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Sign out error:', error);
      // Force navigation to login even if logout fails
      navigate('/login');
    }
  };
  
  const menuItems = [
    { 
      path: '/student-dashboard', 
      label: 'Dashboard',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z" fill="currentColor"/>
      </svg>
    },
    {
      path: '/student-timetable',
      label: 'Time Table',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H17V12H7V10ZM7 14H17V16H7V14ZM7 6H17V8H7V6Z" fill="currentColor"/>
      </svg>
    },
    {
      path: '/student/profile',
      label: 'Profile',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z" fill="currentColor"/>
      </svg>
    },
    {
      path: '/student-attendance-analysis',
      label: 'My Attendance Analysis',
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z" fill="currentColor"/>
      </svg>
    },
  ];

  return (
    <div style={{
      width: 290,
      height: '100vh',
      position: 'fixed',
      left: 0,
      top: 0,
      background: '#1A1C1F',
      display: 'flex',
      flexDirection: 'column',
      padding: '20px 0'
    }}>
      {/* Logo */}
      <div style={{
        padding: '20px 30px',
        marginBottom: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Link to="/student" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none'
        }}>
          <img 
            src="/assets/blackbg.jpg" 
            alt="AttenZef Logo"
            style={{
              height: '50px',
              width: 'auto',
              objectFit: 'contain'
            }}
          />
        </Link>
      </div>

      {/* Navigation Menu */}
      <nav style={{flex: 1}}>
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '15px 40px',
              textDecoration: 'none',
              color: location.pathname === item.path ? '#F04915' : '#FFFFFF',
              background: location.pathname === item.path ? '#FFFFFF' : 'transparent',
              fontSize: 16,
              fontFamily: 'Outfit',
              fontWeight: 500,
              marginBottom: 10,
              gap: 12,
              transition: 'all 0.3s ease'
            }}
          >
            {item.icon}
            {item.label}
          </Link>
        ))}
      </nav>

      {/* Sign Out Button */}
            {/* Sign Out Button */}
      <div style={{padding: '20px 0'}}>
        <button
          onClick={handleSignOut}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            padding: '12px 40px',
            background: 'transparent',
            border: 'none',
            color: '#FFFFFF',
            fontSize: 16,
            fontFamily: 'Outfit',
            fontWeight: 500,
            cursor: 'pointer',
            gap: 12,
            transition: 'all 0.3s ease',
            width: '100%'
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z" fill="currentColor"/>
          </svg>
          Sign Out
        </button>

        {/* Powered by section */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          gap: 8,
          marginTop: 16,
          padding: '0 40px'
        }}>
          <span style={{
            fontSize: 16,
            fontFamily: 'Outfit',
            color: '#888',
            fontWeight: 500
          }}>
            Powered by ZEFTACK
          </span>
        </div>
      </div>
    </div>
  );
};

export default StudentSidebar;
